import React, { useState } from "react";
import "./navbar.css";
import Login from "../../Pages/Login/Login";
import { Menu, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";

export default function Navbar() {
  const { t } = useTranslation();
  const [showLogin, setShowLogin] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  // Smooth scroll handler
  const handleScroll = (e, targetId) => {
    e.preventDefault();
    const section = document.getElementById(targetId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setMenuOpen(false);
    }
  };

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <div className="navbar-logo">
            <img href="#beranda"  onClick={(e) => handleScroll(e, "beranda")} src="https://github.com/user-attachments/assets/7b52c9bf-b44f-4dd9-bfb5-8db5837c6a8a" alt="Logo" />
          </div>

          {/* HAMBURGER ICON */}
          <div
            className="menu-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <X size={26} /> : <Menu size={26} />}
          </div>

          {/* NAV MENU */}
          <ul className={`navbar-menu ${menuOpen ? "active" : ""}`}>
            <li>
              <a href="#beranda" onClick={(e) => handleScroll(e, "beranda")}>
                {t("navbar.beranda")}
              </a>
            </li>
            {/* <li>
              <a href="#tentang" onClick={(e) => handleScroll(e, "tentang")}>
                Tentang Kami
              </a>
            </li> */}
            <li>
              <a href="#layanan" onClick={(e) => handleScroll(e, "layanan")}>
                {t("navbar.layanan")}
              </a>
            </li>
            <li>
              <a href="#faq" onClick={(e) => handleScroll(e, "faq")}>
                {t("navbar.faq")}
              </a>
            </li>
            <li>
              <a href="#kontak" onClick={(e) => handleScroll(e, "kontak")}>
                {t("navbar.kontak")}
              </a>
            </li>
            <li>
              <LanguageSwitcher />
            </li>
            <li>
              <button
                className="login-btn"
                onClick={() => {
                  setShowLogin(true);
                  setMenuOpen(false);
                }}
              >
                {t("navbar.masuk")}
              </button>
            </li>
          </ul>
        </div>
      </nav>

      {/* LOGIN MODAL */}
      <Login show={showLogin} onClose={() => setShowLogin(false)} />
    </>
  );
};

